// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  font-size: 10px;
}

@media screen and (max-width: 768px) {
  html,
  body {
    font-size: 9px;
  }
}

@media screen and (max-width: 480px) {
  html,
  body {
    font-size: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;AACjB;;AAEA;EACE;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,cAAc;EAChB;AACF","sourcesContent":["html,\nbody {\n  font-size: 10px;\n}\n\n@media screen and (max-width: 768px) {\n  html,\n  body {\n    font-size: 9px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  html,\n  body {\n    font-size: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
